import { Step } from 'intro.js-react';
export const DesignSteps: Step[] = [
	{
		element: '.design',
		title: 'Proposal designer',
		intro: (
			<div className="flex flex-col gap-1 text-black">
				<p>
					This page lets you design your program with your team. Think of this
					as the planning space to lay out a strong foundation and scaffolding
					for your proposal.
				</p>
				<p>
					We recommend spending time developing your program design before
					proceeding to the <span className="font-bold">write</span> mode.
					However, you can easily toggle between sections in{' '}
					<span className="font-bold">design</span> and{' '}
					<span className="font-bold">write</span> by clicking on the tabs
					above.
				</p>
			</div>
		),
	},

	{
		element: '.section-outline',
		title: 'Sections outline',
		intro: (
			<div className="flex flex-col gap-1 text-black">
				<p>
					This lets you select the section of the proposal you want to work on.
					If you click on the <span className="font-bold">write</span> tab on
					the top with a section selected, it will jump to that section in the
					write tab.
				</p>
			</div>
		),
		position: 'right',
	},
	{
		element: '.section-guidelines',
		title: 'Section guidance',
		intro: (
			<div className="flex flex-col gap-1 text-black">
				<p>
					This area provides you with guidance on how to provide context for
					this section by framing it as a question. Remember, the AI will pay
					special attention to the response to this question when generating
					output.
				</p>
				<p>
					<span className="font-bold">Tip:</span> We recommend answering this
					question as simple bullet points.
				</p>
			</div>
		),
		position: 'right',
	},
	{
		element: '.suggest-response',
		title: 'Suggest response',
		intro: (
			<div className="flex flex-col gap-1 text-black">
				<p>
					You can use this feature to have the AI come up with a response. The
					AI will use its pretraining, solicitation, information about your
					organization, and any formative documents attached, as well as any
					documents attached to this section, to come up with a response.
				</p>
				<p>
					<span className="font-bold">Note:</span> This is a suggestion only. We
					recommend that you read through and edit or delete any recommendations
					that don’t align with your objectives.
				</p>
			</div>
		),
		position: 'right',
	},
	{
		element: '.ideas',
		title: 'Ideas',
		intro: (
			<div className="flex flex-col gap-1 text-black">
				<p>
					This button lets you add an idea to this section. This could be a
					freeform idea, a data point or any relevant information that you wish
					to provide that can help your team or the AI draft this section in{' '}
					<span className="font-bold">write</span> mode
				</p>
			</div>
		),
		position: 'left',
	},
	{
		element: '.documents',
		title: 'Documents',
		intro: (
			<div className="flex flex-col gap-1 text-black">
				<p>
					You can also associate documents more granularly with each section.
					You can find documents from your repository or upload a new document
					here. The AI will leverage these documents when trying to produce an
					output in <span className="font-bold">write</span> mode as well as any
					suggestion output.
				</p>
			</div>
		),
		position: 'left',
	},
	{
		element: '.comments',
		title: 'Comments',
		intro: (
			<div className="flex flex-col gap-1 text-black">
				<p>
					You can add comments to the proposal for other collaborators to read.{' '}
				</p>
				<p>
					<span className="font-bold">Note:</span> The AI model will not read
					these comments
				</p>
			</div>
		),
		position: 'left',
	},
];
